import { Button, Icons } from '@cockpitai/components/atoms'
import { Typography } from '@cockpitai/components/atoms/Typography'
import { ModalStatic } from '@cockpitai/components/organisms/Modal/ModalStatic'
import { useDeletePanelMutation } from '@cockpitai/integration/panels/hooks/useDeletePanelMutation'

import { useCardMenuStore } from '@cockpitai/store/cardMenu'

export const ModalConfirm = () => {
  const { payload, clear } = useCardMenuStore()

  const deleteChart = useDeletePanelMutation()

  const handleDelete = () => {
    if (payload?.chartId) {
      deleteChart.mutate(payload?.chartId)
    }

    clear()
  }

  return (
    <ModalStatic show={true} fullWidth={false}>
      <div className="modal-confirm w-[33.75rem] p-6">
        <div className="flex items-center justify-between">
          <Typography type="subtitleTwo" className="text-gray-400">
            Deletar gráfico
          </Typography>
          <button type="button" onClick={clear}>
            <Icons.Close className="text-gray-400" />
          </button>
        </div>
        <div className="my-10">
          <Typography type="bodyOne" className="text-gray-400">
            Tem certeza de que deseja deletar este gráfico? Após a confirmação,
            o gráfico não poderá mais ser visualizado neste painel.
          </Typography>
        </div>
        <div className="flex flex-row items-center justify-center gap-2">
          <Button className="basis-1/2" colorScheme="primary" onClick={clear}>
            Cancelar
          </Button>
          <Button
            className="basis-1/2"
            colorScheme="warning"
            onClick={handleDelete}>
            Confirmar
          </Button>
        </div>
      </div>
    </ModalStatic>
  )
}
